// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"06055976","62":"63bff4e5","74":"ded77a17","170":"95098f2a","182":"7eb34b10","266":"3e0cb27f","456":"fcfa56d3","488":"2b7a0799","649":"0d93c400","753":"c75e7726","835":"2d2a1812","977":"4e792476","991":"5f771469"}[chunkId] + ".chunk.js";
};